import actionTypes from './actionTypes';
import type { RateCardSideId } from '../constants';
import type { ICreateCardPayload, IUploadSidePayload } from '../types';

const actions = {
  // `cardId` is null only in the create wizard, where `details` says what to mint the card from: the
  // shell is created by the first upload rather than by reaching the import step.
  uploadSideRequest: (payload: IUploadSidePayload) => ({
    type: actionTypes.UPLOAD_SIDE_REQUEST,
    payload,
  }),
  // `token` identifies which attempt the outcome belongs to: uploads run concurrently per side
  // (takeEvery), so a superseded response must not flip the attempt that replaced it.
  uploadSideSuccess: (payload: { side: RateCardSideId; token: number; uploadId: string }) => ({
    type: actionTypes.UPLOAD_SIDE_SUCCESS,
    payload,
  }),
  uploadSideError: (payload: {
    side: RateCardSideId;
    token: number;
    message?: string;
    retryable?: boolean;
    prominent?: boolean;
  }) => ({
    type: actionTypes.UPLOAD_SIDE_ERROR,
    payload,
  }),
  clearSide: (payload: { side: RateCardSideId }) => ({ type: actionTypes.CLEAR_SIDE, payload }),

  downloadTemplateRequest: (payload: { engineVersionId: string; side: RateCardSideId }) => ({
    type: actionTypes.DOWNLOAD_TEMPLATE_REQUEST,
    payload,
  }),
  downloadTemplateSettled: (payload: { side: RateCardSideId }) => ({
    type: actionTypes.DOWNLOAD_TEMPLATE_SETTLED,
    payload,
  }),

  createRequest: (payload: ICreateCardPayload) => ({
    type: actionTypes.CREATE_REQUEST,
    payload,
  }),
  createSuccess: (payload: { cardId: string }) => ({ type: actionTypes.CREATE_SUCCESS, payload }),
  createError: (payload: { validations: Record<string, string[]> | null }) => ({
    type: actionTypes.CREATE_ERROR,
    payload,
  }),

  clearStore: () => ({ type: actionTypes.CLEAR_STORE }),
};

export default actions;
